import { render, staticRenderFns } from "./floor2Unit.vue?vue&type=template&id=289f8bd6&scoped=true"
import script from "./floor2Unit.vue?vue&type=script&lang=js"
export * from "./floor2Unit.vue?vue&type=script&lang=js"
import style0 from "./floor2Unit.vue?vue&type=style&index=0&id=289f8bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289f8bd6",
  null
  
)

export default component.exports